import React, { useEffect } from 'react';
import { Landing } from './pages/Landing';
import { initMetaPixel } from './utils/metaPixel';
interface AppProps {
  /** Muestra la barra de compra fija al pie en móvil mientras se navega la página. */
  barraCompraFija?: boolean;
  /** Muestra los avisos de "compra verificada" cada 40–60 segundos. */
  avisosDeCompra?: boolean;
}
export function App({
  barraCompraFija = true,
  avisosDeCompra = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <Landing barraCompraFija={barraCompraFija} avisosDeCompra={avisosDeCompra} data-id="element-0" data-mp="2mmcd05ohp6ap" />;
}